import ProductReviewMixin from '~/mixins/ProductReviewMixin'

// Approach for SSR
const vueRateIt = process.client ? require('vue-rate-it') : {}

export default {
  mixins: [ProductReviewMixin],
  components: { StarRating: vueRateIt.StarRating },
  props: {
    fixedPoints: {
      type: Number,
      default: 1,
    },
    increment: {
      type: Number,
      default: 0.01,
    },
    itemSize: {
      type: Number,
      default: 30,
    },
    maxRating: {
      type: Number,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    showRating: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
      validator: value => {
        return 0 <= value <= 100
      },
    },
  },
  data() {
    return {
      maxRatingProp: null,
      starRatingComponent: null,
    }
  },
  beforeMount() {
    this.maxRatingProp = this.maxRating ? this.maxRating : this.$themeSettings.components.StarRating.starsCount
  },
  methods: {
    emitInput(value) {
      this.$emit('input', this.transformStarsToRating(value))
    },
  },
  computed: {
    valueToStars() {
      return this.transformRatingToStars(this.value)
    },
  },
}
